import React, { useContext, useEffect, useRef, useState } from 'react'

import { useElements, useStripe } from '@stripe/react-stripe-js'
import SuccessPaymentModal from './successPaymentModal'
import classNames from 'classnames'
import verifiedbyvisamastercard from '../../assets/verifiedbyvisamastercard.svg'
import verifiedbyvisa from '../../assets/verifiedbyvisa.svg'
import RechargeContext from 'contexts/rechargeContext'
import { toast } from 'react-toastify'
import SuccessPaymentCarteModal from 'containers/rechargePrepayee/successPaymentCarteModal'
import BeneficiaryContext from 'contexts/beneficiaryContext'
import { ComponentViewType, Volume, VolumeProvider } from '@getvolume/react'
import type { PaymentStatusResponse, VolumeEvent } from '@getvolume/volume-shared'
import IconCarte from '../../assets/iconCarteBancaire.svg'
import IconCalendrier from '../../assets/iconCalendrier.svg'

interface props {
  clientSecret: any
  confirmPayment: any
  SendValue?: any
  ProviderCode?: any
  isTelecom?: boolean
  isOrange?: boolean
  isOoredoo?: boolean
  buttonClicked?: boolean
  selectionCount?: number
  functionTracks: any
  modalCarte?: boolean
  voucher?: string,
  setIsSuccess?:(val:boolean)=>void
  // iconOperateur?: string


}

const PaiementForm: React.FC<props> = ({
  clientSecret,
  confirmPayment,
  SendValue,
  setIsSuccess,
  ProviderCode,
  isTelecom,
  isOrange,
  isOoredoo,
  buttonClicked,
  selectionCount,
  functionTracks,
  // iconOperateur,
 
  modalCarte= false,
  voucher
}) => {
  const elements = useElements()
  const stripe = useStripe()

  const { recharges, setRecharges } = useContext(RechargeContext)
  const { setBeneficiaries } = useContext(BeneficiaryContext)

  const cardNumberRef = useRef<HTMLInputElement>(null)
  const cardExpiryRef = useRef<HTMLInputElement>(null)
  const cardCvcRef = useRef<HTMLInputElement>(null)

  const [cardNumberElement, setCardNumberElement] = useState<any>(null)
  const [cardExpiryElement, setCardExpiryElement] = useState<any>(null)
  const [cardCvcElement, setCardCvcElement] = useState<any>(null)

  const [successPayment, setSuccessPayment] = useState('')
  const [openModalSuccessPayment, setOpenModalSuccessPayment] = useState(false)
  const [countStatus, setCountStatus] = useState(1)
  const [iconOperateur, setIconOperateur] = useState('')

  const [isButtonClicked, setIsButtonClicked] = useState(false)
  const [isInvoices,setIsInvoices]= useState('')

   const [cardComplete, setCardComplete] = useState({
      number: false,
      expiry: false,
      cvc: false,
    })
    

  const style ={
    base:{
      color:'#5754E5',
       '::placeholder': {
        color: '#D1D1FF', 
      },
      
    }
  }
 
  const closeModalSuccessPayment = () => {
    setOpenModalSuccessPayment(false)
  }

  useEffect(() => {
    if (!stripe || !elements) {
      return
    }

    const cardNumberElement = elements.create('cardNumber', { style ,  placeholder: 'Numéro de carte',})
    const cardExpiryElement = elements.create('cardExpiry', { style ,  placeholder: 'Date d’expiration - mm/aaaa',})
    const cardCvcElement = elements.create('cardCvc', { style ,  placeholder: 'CVC',})

    if (cardNumberRef.current) {
      cardNumberElement.mount(cardNumberRef.current)
    }

    if (cardExpiryRef.current) {
      cardExpiryElement.mount(cardExpiryRef.current)
    }

    if (cardCvcRef.current) {
      cardCvcElement.mount(cardCvcRef.current)
    }
    cardNumberElement.on('change', (event: any) => {
      setCardComplete((prev) => ({ ...prev, number: event.complete }))
    })

    cardExpiryElement.on('change', (event: any) => {
      setCardComplete((prev) => ({ ...prev, expiry: event.complete }))
    })
    cardCvcElement.on('change', (event: any) => {
      setCardComplete((prev) => ({ ...prev, cvc: event.complete }))
    })

    setCardNumberElement(cardNumberElement)
    setCardExpiryElement(cardExpiryElement)
    setCardCvcElement(cardCvcElement)

    // cardNumberElement.update( {style, placeholder:'Numéro de carte'})
    // cardExpiryElement.update({ placeholder: 'Date' })
    // cardCvcElement.update({ placeholder: 'CVC' })

    return () => {
      cardNumberElement.destroy()
      cardExpiryElement.destroy()
      cardCvcElement.destroy()
    }
  }, [stripe, elements])

  const handleSubmit = async (e: any) => {
    if(isButtonClicked) return
    
    setIsButtonClicked(true)
    e.preventDefault()
    if (!stripe || !elements || !cardNumberElement) {
      return
    }
    const clientSecretKey = clientSecret

    if (!clientSecretKey) {
      toast.error('Erreur serveur, veuillez réessayer plus tard')
    }

    const {paymentIntent} = await stripe.confirmCardPayment(clientSecretKey, {
      payment_method: {
        card: cardNumberElement,
      },
    })
    // if(error){
    //   toast.error('Erreur de paiement')
    //   return
    // }
    functionTracks('3')

    // if (successPayment === 'undefined') {
    //   setCountStatus(countStatus + 1)
    //   setCountNbClick(countNbClick + 1)
    //   if (countStatus === 2 && countNbClick === 2) {
    //     setIsButtonClicked(true)
    //     // setOpenModalSuccessPayment(true)
    //   }
    //   //console.log('is undefined !')
    //   setRecharges({})
    // }
    if (paymentIntent?.status === 'succeeded') {
      confirmPayment()
      setIsInvoices('recharge')
      setIsButtonClicked(true)
      setOpenModalSuccessPayment(true)
      setSuccessPayment(`${paymentIntent?.status}`)
      setIconOperateur(recharges?.iconOperateur|| '')
      setRecharges({})
      setBeneficiaries(null)
    }else{
      setIsSuccess?.(false)
    }
  }

  const generateUniqueReference = () => {
  return `payment_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`
}
const generateUniqueMerchantId = () => {
  return `merchant_${Date.now()}_${Math.random().toString(36).substr(2, 5)}`
}
  return (
    <div>


       {/* {ProviderCode === 'Telecom' && (
        <div className={classNames(isTelecom ? '' : 'hidden')}>
          <form onSubmit={handleSubmit} id="payment-form"  autoComplete="off">
            <div className="h-[80px] sm:h-[110px]">
              <div className="relative mt-3 flex justify-center">
                <div
                  id="card-number"
                  ref={cardNumberRef}
                  contentEditable="true"
                  className="p-2 border w-1/2 2xl:w-[400px] sm:w-[300px] xs:w-[300px] h-[56px] rounded-xl bg-[#F9FAFB] placeholder:text-[#9CA3AF]"
                >
                </div>
              </div>
            </div>

            <div className="h-[80px] sm:h-[110px] w-full">
              <div className="relative flex justify-center">
                <div
                  id="card-expiry"
                  ref={cardExpiryRef}
                  contentEditable="true"
                  className="p-2 border w-1/2 2xl:w-[400px] sm:w-[300px] xs:w-[300px] h-[56px] rounded-xl bg-[#F9FAFB] placeholder:text-[#9CA3AF]"
                ></div>
              </div>
            </div>

            <div className="h-[80px] sm:h-[110px]">
              <div className="relative flex justify-center">
                <div
                  id="card-cvc"
                  ref={cardCvcRef}
                  contentEditable="true"
                  className="p-2 border w-1/2 2xl:w-[400px] sm:w-[300px] xs:w-[300px] h-[56px] rounded-xl bg-[#F9FAFB] placeholder:text-[#9CA3AF]"
                ></div>
              </div>
            </div>

            <div className="flex justify-center my-2 items-center ">
              <button
                className={classNames(
                  `text-[18px] text-[#FFF] w-1/2 p-2 h-[56px] rounded-xl sm:w-[300px] xs:w-[300px]
                  ${isButtonClicked ? 'bg-[#d3d3d3] ' : 'bg-[#4743C9]'}
                    `,
                  )}
                disabled={isButtonClicked}
              >
                Payer <span className="pl-4 font-semibold">{SendValue} EUR</span>
              </button>
            </div>

            <div className="text-center text-[15] 2md:text-[15px] 2md:w-[335px] xs:text-[20px] sm:text-[13px] text-normal mx-[60px] sm:mx-[30px] xs:mx-[30px] 2xl:w-[400px] md:mx-0 text-[#6B7280] sm:w-[450px] xs:w-[450px] w-[550px] mt-5">
              Selon votre établissement bancaire, vous pourrez être redirigé vers la page d&rsquo;authentification de
              votre banque avant la validation de votre paiement.
            </div>
            <div className="text-center text-[15px] xs:text-[12px] sm:text-[12px] text-normal text-[#6B7280]">
              <br /> Sécurisé par :
            </div>
            <div className="flex justify-center items-center">
              <img src={verifiedbyvisamastercard} className="w-32 h-32 mr-5" />
              <img src={verifiedbyvisa} className="w-32 h-32" />
            </div>
          </form>
        </div>
      )}

      {ProviderCode === 'Orange' && (
        <div className={classNames(isOrange ? '' : 'hidden')}>
          <form onSubmit={handleSubmit} id="payment-form" autoComplete="no">
            <div className="h-[80px] sm:h-[110px]">
              <div className="relative mt-3 flex justify-center">
                <div
                  id="card-number"
                  ref={cardNumberRef}
                  className="p-2 border w-1/2 2xl:w-[400px] sm:w-[300px] xs:w-[300px] h-[56px] rounded-xl bg-[#F9FAFB] placeholder:text-[#9CA3AF]">
                </div>
              </div>
            </div>

            <div className="h-[80px] sm:h-[110px] w-full">
              <div className="relative flex justify-center">
                <div
                  id="card-expiry"
                  ref={cardExpiryRef}
                  className="p-2 border w-1/2 2xl:w-[400px] sm:w-[300px] xs:w-[300px] h-[56px] rounded-xl bg-[#F9FAFB] placeholder:text-[#9CA3AF]"
                ></div>
              </div>
            </div>

            <div className="h-[80px] sm:h-[110px]">
              <div className="relative flex justify-center">
                <div
                  id="card-cvc"
                  ref={cardCvcRef}
                  className="p-2 border w-1/2 2xl:w-[400px] sm:w-[300px] xs:w-[300px] h-[56px] rounded-xl bg-[#F9FAFB] placeholder:text-[#9CA3AF]"
                ></div>
              </div>
            </div>

            <div className="flex justify-center my-2 items-center ">
              <button
                className={classNames(
                  `text-[18px] text-[#FFF] w-1/2 p-2 h-[56px] rounded-xl sm:w-[300px] xs:w-[300px]
                  ${isButtonClicked 
                    ?
                     'bg-[#d3d3d3] ' :
                     'bg-[#4743C9]'
                    }
                  `,
                )}
                disabled={isButtonClicked}
              >
                Payer <span className="pl-4 font-semibold">{SendValue} EUR</span>
              </button>
            </div>

            <div className="text-center text-[15] 2md:text-[15px] 2md:w-[335px] xs:text-[20px] sm:text-[13px] text-normal mx-[60px] sm:mx-[30px] xs:mx-[30px] 2xl:w-[400px] md:mx-0 text-[#6B7280] sm:w-[450px] xs:w-[450px] w-[550px] mt-5">
              Selon votre établissement bancaire, vous pourrez être redirigé vers la page d&rsquo;authentification de
              votre banque avant la validation de votre paiement.
            </div>
            <div className="text-center text-[15px] xs:text-[12px] sm:text-[12px] text-normal text-[#6B7280]">
              <br /> Sécurisé par :
            </div>
            <div className="flex justify-center items-center">
              <img src={verifiedbyvisamastercard} className="w-32 h-32 mr-5" />
              <img src={verifiedbyvisa} className="w-32 h-32" />
            </div>
          </form>
        </div>
      )} */}



      {/* ....................... */}

      {/* {ProviderCode === 'Ooredoo' && ( 
      <div className={classNames(isOoredoo ? '' : 'hidden')}>  */}

    {/* <VolumeProvider
      applicationId="dbf2bc7e-aabf-412a-ac03-a96bcfef456d"
      volumeEnvironment="sandbox"
      onEvent={(event: VolumeEvent) => {
            console.log(JSON.stringify(event))
          }}
    >
      <Volume
        amount={25}
        currency='EUR'
        reference= {'easy12345'}
        country='FR'
        merchantPaymentId= {'easy12345'}
        metadata ={{}}
        paymentStatusCallback={
            (paymentStatus: PaymentStatusResponse) => {
                console.log("I've got a new status: " + JSON.stringify(paymentStatus))
            }
        }
        componentViewTypeCallback={
            (componentViewType: ComponentViewType) => {
                console.log("Component UI type is: " + componentViewType)
            }
        }
      />
    </VolumeProvider>  */}
   <form className="w-full flex flex-col gap-8  lg:px-[24px] items-center justify-center  " onSubmit={handleSubmit} id="payment-form"  autoComplete="off">
    <h1 className='h2 flex items-start w-full'>Payez avec votre carte en toute sécurité</h1>
          <div className=" w-full relative  pl-4 flex  gap-4 items-center justify-center overflow-hidden h-[56px] rounded-[16px] border border-[#AEB6FB]">
           <img src={IconCarte} width={24} height={24} alt=''/>
            <div
              id="card-number"
              ref={cardNumberRef}
              className=" w-full"
            ></div>
          </div>
    

        <div className=" w-full relative  pl-4 flex  gap-4 items-center justify-center overflow-hidden h-[56px] rounded-[16px] border border-[#AEB6FB]">
           <img src={IconCalendrier} width={24} height={24} alt=''/>
            <div
              id="card-expiry"
              ref={cardExpiryRef}
              className=" w-full"
            ></div>
          </div>
        

         <div className=" w-full relative  pl-4 flex  gap-4 items-center justify-center overflow-hidden h-[56px] rounded-[16px] border border-[#AEB6FB]">
            <div
              id="card-cvc"
              ref={cardCvcRef}
              className="w-full"
            ></div>
          </div>
       
          <button
            className={classNames(
              `text-[18px] font-semibold text-[#FFF] w-full h-[56px] rounded-[16px]
                  ${!(cardComplete.cvc && cardComplete.expiry && cardComplete.number) || isButtonClicked ? 'bg-[#D1D1FF] ' : 'bg-[#5754E5]'}
                  `,
            )}
            disabled={!(cardComplete.cvc && cardComplete.expiry && cardComplete.number) || isButtonClicked}
          >
            Payer <span className="pl-4 ">{SendValue} EUR</span>
          </button>

        <p className="text-center text-[14px]  text-[#6B7280] sm:w-full  w-[550px]">
          Selon votre établissement bancaire, vous pourrez être redirigé vers la
           page d&rsquo;authentification de votre
          banque avant la validation de votre paiement.<br/>
        </p>
        <div className="text-center text-[14px] text-[#6B7280]">
         Sécurisé par :
        </div>
        <div className="flex justify-center items-center">
          <img src={verifiedbyvisamastercard} className="w-32 h-32 " />
          <img src={verifiedbyvisa} className="w-32 h-32" />
        </div>
      </form>  
      
      {/* </div> 
     )} */}

      {successPayment !== '' &&  (
        modalCarte ?

        <SuccessPaymentCarteModal
          isOpen={openModalSuccessPayment}
          closeModal={closeModalSuccessPayment}
          successPayment={successPayment}
          voucher={voucher}

        />
        :
        <SuccessPaymentModal
        isOpen={openModalSuccessPayment}
        closeModal={closeModalSuccessPayment}
        successPayment={successPayment}
        iconOperateur={iconOperateur}
        isInvoices={'Recharge'}
      />

        )
        }
    </div>
  )
}

export default PaiementForm
